<template>
	<div>
		<!-- 评审详情 -->
		<div class="header">
			<div class="col-ter">
				<div class="col-ter">
					<span class="col-tit">名称：</span>
					<el-input v-model="selectObj.name" clearable></el-input>
				</div>
				<div class="col-ter" style="margin-left: 100px;">
					<span class="col-tit">单位：</span>
					<el-input v-model="selectObj.school" clearable></el-input>
				</div>
				<el-button type="primary" style="margin-left: 20px;" @click="getTable">查询</el-button>
			</div>
		</div>
		<el-table id="table" :header-cell-style="tableStyle" border ref="multipleTable" :data="topicList" style="width: 100%">
			<el-table-column type="index" label="编号" width="50"></el-table-column>
			<el-table-column prop="title" label="名称" width="400"></el-table-column>
			<el-table-column prop="unit" label="所属学校" width="200"></el-table-column>
			<el-table-column prop="groupName" label="所属评审组"></el-table-column>
			<el-table-column prop="fraction1" label="专家1分数"></el-table-column>
			<el-table-column prop="fraction2" label="专家2分数"></el-table-column>
			<el-table-column prop="fraction3" label="专家3分数"></el-table-column>
			<el-table-column prop="average" label="平均分"></el-table-column>
		</el-table>
		<download-excel style="margin-top: 20px;width: max-content;" :fields="fields" :data="topicList" type="xls" name="评审结果.xls">
			<el-button type="primary">导出Excel</el-button>
		</download-excel>
		<!-- <div style="margin-top: 20px;"><el-button type="primary" @click="exportExcel">导出Excel</el-button></div> -->
	</div>
</template>

<script>
import JsonExcel from 'vue-json-excel';
import { reviewProgressList } from '@/api/after/newInterface.js';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
export default {
	components: {
		DownloadExcel: JsonExcel
	},
	data() {
		return {
			fields: {
				编号: 'numIndex', //对应字段
				名称: 'title',
				作者: 'nameStr',
				所属学校: 'unit',
				所属评审组: 'groupName',
				专家1分数: 'fraction1',
				专家2分数: 'fraction2',
				专家3分数: 'fraction3',
				平均分: 'average',
				评语: 'note'
			},
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#7e9be2',
				color: '#fff'
			},
			topicList: [],
			// 详情
			detailedList: [{ declareName: '详情' }],
			userTitle: '',
			selectObj: {
				name: '',
				school: ''
			},
			projectId: '',
			// 导出的表头及其对应json的key值
			jsonFields: {
				用户名: 'name',
				账号: 'id',
				职业: 'job',
				生日: 'birthday',
				地址: 'address'
			}
		};
	},
	mounted() {
		this.projectId = sessionStorage.getItem('projectId');
		this.getTable();
	},
	methods: {
		// 导出excel
		exportExcel() {
			let exportFileName = '评审结果.xlsx';
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), exportFileName);
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		//talbe
		getTable() {
			reviewProgressList({ pageNumber: 1, pageSize: 999, id: this.projectId, type: 1 }).then(res => {
				this.topicList = res.data.records;
				if (this.topicList.length > 0) {
					this.topicList.forEach((item, index) => {
						this.$set(item, 'numIndex', index + 1);
						if (item.author) {
							this.$set(item, 'nameStr', `${item.author},${item.userName}`);
						} else {
							this.$set(item, 'nameStr', `${item.userName}`);
						}
					});
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.header {
	font-weight: bold;
	font-size: 20px;
	margin-bottom: 20px;
}
.col-ter {
	display: flex;
	align-items: center;
}
.col-tit {
	color: #7e9be2;
	min-width: max-content;
}
</style>
